import { ActivityLog } from "@widgets/dashboard/activity-log";
import { ErrorsChart } from "@widgets/dashboard/errors-chart";
import { Quotas } from "@widgets/dashboard/quotas";
import { RecentUsers } from "@widgets/dashboard/recent-users";
import { StatsCards } from "@widgets/dashboard/stats-cards";
import { TablesOverview } from "@widgets/dashboard/tables-overview";
import { TrafficChart } from "@widgets/dashboard/traffic-chart";

export default function DashboardPage() {
	return (
		<div className="space-y-6 w-full">
			<StatsCards />

			<section className="grid gap-4 lg:grid-cols-3">
				<TrafficChart />
				<ErrorsChart />
			</section>

			<section className="grid gap-4 lg:grid-cols-3">
				<TablesOverview />
				<Quotas />
			</section>

			<section className="grid gap-4 lg:grid-cols-3">
				<RecentUsers />
				<ActivityLog />
			</section>
		</div>
	);
}
